<template>
  <div>
    <div class="actions">
      <div class="edit" data-toggle="modal" :data-target="'#modal-edit'+item_collection.id"><span class="material-icons">edit</span></div>
      <div class="edit" data-toggle="modal" :data-target="'#modal-'+item_collection.id"><span class="material-icons">swap_vert</span></div>
      <div class="delete"><span class="material-icons" @click="deleteCollection()">close</span></div>
    </div>
    <div class="modal fade" tabindex="-1"  :id="'modal-'+item_collection.id" ref="modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">Priekšmetu pārvietošana</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="alert alert-primary">
                  Šo darbību nebūs iespējams atcelt.
                </div>
              </div>
              <hr>
              <div class="col-12">
                <div class="form-group">
                  <label for="from">No</label>
                  <input class="form-control" type="text" :value="item_collection.title +' ('+ item_collection.items_count + ')'" disabled>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label for="to">Uz</label>
                  <v-select  v-model="new_collection_id"
                             :options="item_collections_list"
                             :reduce="option => option.id"
                             :getOptionLabel="option => `${option.title} (${option.items_count})`"
                             placeholder="Izvēlies jauno kolekciju"
                  />
                </div>
              </div>
              <div>
                <div class="col-12">
                  <label>Vai dzēst veco kolekciju informācijas atjaunošanas</label>
                  <div class="selectButtonsWrapper">
                    <div class="selectBtn" :class="{'active':should_delete == true}"  @click="should_delete = true">Jā</div>
                    <div class="selectBtn" :class="{'active':should_delete == false}" @click="should_delete = false">Nē</div>
                  </div>
                </div>
              </div>
              <div class="col-12 text-right" >
                <button class="btn btn-primary" @click="changeCollection()" v-if="new_collection_id && loading == false">Pārvietot priekšmetus</button>
                <button v-else-if="loading == true" class="btn btn-primary" disabled>Notiek pārvietošana..</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1"  :id="'modal-edit'+item_collection.id" ref="modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">Nosaukuma maiņa / {{item_collection.title}}</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="alert alert-primary">
                  Šo darbību nebūs iespējams atcelt.
                </div>
              </div>
              <hr>
              <div class="col-12">
                <div class="form-group">
                  <label for="from">Esošais nosaukums</label>
                  <input class="form-control" type="text" :value="item_collection.title" disabled>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label for="to">Jaunais nosaukums</label>
                  <input class="form-control" type="text" v-model="new_title">
                  <small class="text-danger d-block" v-if="errors && errors.new_title">{{errors.new_title[0]}}</small>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="item_type">Kolekcijas priekšmetu veids</label>
                  <select name="item_type" id="item_type" class="form-control" v-model="item_type">
                    <option value="Audio-vizuālie un IT priekšmeti">Audio-vizuālie un IT priekšmeti</option>
                    <option value="Dabas Priekšmeti">Dabas Priekšmeti</option>
                    <option value="Jāprecizē">Jāprecizē</option>
                    <option value="Lietiskie priekšmeti">Lietiskie priekšmeti</option>
                    <option value="Rakstiskie priekšmeti">Rakstiskie priekšmeti</option>
                    <option value="Tēlojošie priekšmeti">Tēlojošie priekšmeti</option>
                  </select>
                  <small class="text-danger" v-if="errors && errors.item_type">{{errors.item_type[0]}}</small>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="nmkk_number">NMKK kolekcijas numurs</label>
                  <input class="form-control" type="text" v-model="nmkk_number">
                  <small>NMKK kolekcijas numurs, kas izveidots pievienojot kolekciju NMKK (2003V00105)</small>
                  <small class="text-danger d-block" v-if="errors && errors.nmkk_number">{{errors.nmkk_number[0]}}</small>
                </div>
              </div>
              <div class="col-12 text-right" >
                <button class="btn btn-primary" @click="update()" v-if="new_title && loading == false">Mainīt nosaukumu</button>
                <button v-else-if="loading == true" class="btn btn-primary" disabled>Notiek nosaukuma maiņa..</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['item_collection'],
  mounted()
  {
    var that = this;
    EventBus.$on('should_update_childs', (item_collections_list) =>{
      that.item_collections_list = item_collections_list;
    });

    this.new_title = this.$props.item_collection.title;
    this.item_type = this.$props.item_collection.item_type;
    this.nmkk_number = this.$props.item_collection.nmkk_number;
  },
  data()
  {
    return{
      item_collections_list:[],
      new_collection_id:null,
      should_delete: false,
      loading: false,
      errors:[],

      new_title:"",
      item_type:"",
      nmkk_number:"",
    }
  },
  methods:{
    deleteCollection(collection_id = this.$props.item_collection.id)
    {
      var that = this;
      var data = {collection_id: collection_id}
      that.$swal.fire({
        title: 'Vai tiešām vēlaties dzēst priekšmetu kolekciju?',
        text: "Priekšmeta kolekcija tiks neatgriezeniski dzēsts.",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#E53935',
        cancelButtonColor: '#888787',
        confirmButtonText: 'Dzēst',
        cancelButtonText: 'Atcelt'
      }).then((result) => {
        if (result.value) {
          axios.post('/dashboard/api/delete_collection',data)
              .then(response => {
                if(response.data.status == 'ok')
                {
                  that.$toast.open(response.data.message);
                  EventBus.$emit('should_reload');
                }
                else {
                  that.$toast.warning(response.data.message);
                }
              });
        }
      });
    },
    update()
    {
      this.errors = [];
      this.loading = true;
      var that = this;
      var data = {
        collection_id:this.$props.item_collection.id,
        title: this.new_title,
        nmkk_number: this.nmkk_number,
        item_type: this.item_type
      };
      axios.post('/dashboard/api/update_collection',data)
          .then(response => {
            that.loading = false;
            if(response.data.status == 'ok')
            {
              $('#modal-edit'+this.$props.item_collection.id).modal('hide');
              that.$toast.open(response.data.message);
              EventBus.$emit('should_reload');
            }
            else {
              that.$toast.warning(response.data.message);
              that.errors = response.data.errors;
            }
          })
    },
    changeCollection()
    {
      this.errors = [];
      this.loading = true;
      var that = this;
      var data = {
        old_collection_id:this.$props.item_collection.id,
        new_collection_id:this.new_collection_id,
        should_delete:this.should_delete
      };
      axios.post('/dashboard/api/bulk_collection_update',data)
          .then(response => {
            that.loading = false;
            if(response.data.status == 'ok')
            {
              $('#modal-'+this.$props.item_collection.id).modal('hide');
              that.$toast.open(response.data.message);
              EventBus.$emit('should_reload');
            }
            else {
              that.$toast.warning(response.data.message);
              that.errors = response.data.errors;
            }
          })

    }
  }

}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.actions{
  display:flex;
  align-items: center;

  .delete{
    display:flex;
    align-items: center;
    justify-content: center;
    cursor:pointer;
    margin-left:10px;
    width:24px;
    height:24px;
    background-color:#ddd;
    color:#fff;
    transition:all .2s ease-in-out;
    border-radius:100%;
    &:hover{
      background-color:$red;
    }
  }
}

.selectButtonsWrapper{
  display:flex;
  gap:10px;
  .selectBtn{
    padding:10px 15px;
    border-radius:5px;
    border:2px solid #eee;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: bold;
    color:#777;
    line-height:1;
    transition: .2s all;
    &.active{
      border-color:$blue;
      color:#333;
    }
  }
}
</style>